import { useEffect, useState } from 'react';

import { getIdleState, onGem } from '../../lib/idle/idleStore';
import Styles from './GemDrops.module.css';
import GemIcon from './GemIcon';

let nextId = 0;

const LIFETIME_MS = 2300; // a hair longer than the slowest animation (the number, 2.2s)

// Same burst as CoinDrops, for gems: "+1" rises while the gem hops to one side
// and drops. Mount it inside a positioned parent (it fills it).
const GemDrops = () => {
  const [drops, setDrops] = useState([]);

  useEffect(
    () =>
      onGem(({ amount }) => {
        if (getIdleState().settings.coinPops === false) return;
        const id = ++nextId;
        const dir = Math.random() < 0.5 ? -1 : 1;
        const side = dir * (55 + Math.random() * 35);
        const jitter = (Math.random() - 0.5) * 30;
        setDrops((d) => [...d.slice(-8), { id, amount, side, jitter }]);
        setTimeout(() => setDrops((d) => d.filter((x) => x.id !== id)), LIFETIME_MS);
      }),
    [],
  );

  return (
    <div className={Styles.layer} aria-hidden="true">
      {drops.map((d) => (
        <div
          key={d.id}
          className={Styles.drop}
          style={{ '--side': `${d.side}px`, '--jitter': `${d.jitter}px` }}
        >
          <span className={Styles.number}>+{d.amount}</span>
          <span className={Styles.gemX}>
            <span className={Styles.gemY}>
              <GemIcon size={30} />
            </span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default GemDrops;